var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"ml-2 mr-2 mt-4 mb-6"},[_c('h2',{staticClass:"ml-2 mr-2 mt-4 mb-6"},[_vm._v("Här kommer det ett schema...")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }